import {TextField, InputAdornment, IconButton} from '@mui/material'
import {SearchOutlined, Clear} from '@mui/icons-material'
import {useEffect, useState, forwardRef, useImperativeHandle} from 'react'
import {useDebounce} from 'use-debounce';
import {useTranslation} from 'react-i18next';
import {getCaseListBySearchBar} from "../../../api/CaseAPI";

interface SearchBarProps {
    pushSearchResult: (result: any) => void;
}

const SearchBar = forwardRef<any, SearchBarProps>(({pushSearchResult}, ref) => {
    const { t } = useTranslation("common");
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearchTerm] = useDebounce(searchTerm, 200);

    useImperativeHandle(ref, () => {
        return {
            clearSearch() {
                setSearchTerm('');
            }
        }
    }, []);

    useEffect(() => {
        if (debouncedSearchTerm !== undefined) {
            getCaseListBySearchBar(debouncedSearchTerm).then(r => pushSearchResult(r));
        }
    }, [debouncedSearchTerm]);


    const onChange = async (value) => {
        setSearchTerm(value);
    }

    return (
        <TextField
            id="search"
            label={t('search')}
            color="secondary"
            onChange={(e) => onChange(e.target.value)}
            value={searchTerm}
            fullWidth={true}
            variant='standard'
            size='small'
            margin="dense"
            ref={ref}
            slotProps={{
                input: {
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchOutlined />
                        </InputAdornment>
                    ),
                    endAdornment: (
                        <InputAdornment position="end">
                            {searchTerm.length > 0 && <IconButton onClick={() => onChange('')}><Clear /></IconButton>}
                        </InputAdornment>
                    ),
                },
                inputLabel: {
                    shrink: searchTerm.length > 0,
                    sx: { marginLeft: 4 }
                }
            }}
        />
    )
})

export default SearchBar;